import authService from '../api-authorization/AuthorizeService'

export class ApiRequests {


	async getDataByUrl(url, callbackFunc) {
		const token = await authService.getAccessToken();
		const reqParams = {	
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
			},
			credentials: "include",
			cache: "no-cache"
		};

		if (callbackFunc && reqParams) {
		}
		fetch(url, reqParams).then(async response => {
			
			if (!response.ok) {
				const error = (data && data.message) || response.status;
				return Promise.reject(error);
			}
			
			const isJson = response.headers.get('content-type')?.includes('application/json');
			const data = isJson ? await response.json() : "";

			callbackFunc(data);
		})
		.catch(error => {
			callbackFunc("Error!");
		});
	}

	async getDataByUrlWithParam(url, params, callbackFunc) {
		url = new URL(window.location.origin + '/' + url);
		const token = await authService.getAccessToken();


		const reqParams = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			credentials: "include",
			cache: "no-cache",
			body: JSON.stringify(params)
		};

		if (callbackFunc && reqParams) {
			fetch(url, reqParams)
				.then(async response => {
					const data = await response.json();
					callbackFunc(data, response);
				})
				.catch(error => {
					callbackFunc(error);
				});
		}
		else {
			const response = await fetch(url, reqParams);

			if (!response.ok) {
				return "";
			}

			const isJson = response.headers.get('content-type')?.includes('application/json');
			return isJson ? response.json() : "";
		}
	}


	async setDataByUrl(url, params, callbackFunc) {

		const token = await authService.getAccessToken();

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			credentials: "include",
			cache: "no-cache",
			body: JSON.stringify(params)
		};

		fetch(url, requestOptions)
			.then(async response => {
				
				if (!response.ok) {
					const error = (data && data.message) || response.status;
					return Promise.reject(error);
				}
				const isJson = response.headers.get('content-type')?.includes('application/json');
				const data = isJson ? await response.json() : "";
				callbackFunc(data);
 
			})
			.catch(error => {
				callbackFunc("");
			});
	}
}

const apiRequests = new ApiRequests();
export default apiRequests;